module.exports = __webpack_public_path__ + "media/images/tag-cbbc6f2e0ce1d90596f9ca73253c5472.svg";